import { Box, Typography, Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const CaseStudyCard = ({ image, title, description, link }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate(link)}
      sx={{
        width: { xs: "280px", sm: "320px" },
        borderRadius: "1rem",
        overflow: "hidden",
        backgroundColor: "white",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        cursor: "pointer",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.02)",
        },
        mb: { xs: 2, sm: 0 },
        padding: "0.5rem",
        display: "flex",
        flexDirection: "column",
        height: {xs: "430px", sm: "100%"},
      }}
    >
      {/* Image Container */}
      <Box 
        sx={{ 
          width: "100%", 
          height: "180px",
          borderRadius: "0.8rem",
          overflow: "hidden",
          mb: 2,
          flexShrink: 0,
        }}
      >
        <img
          src={image}
          alt={title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      {/* Content Container */}
      <Box 
        sx={{ 
          padding: "0 0.5rem",
          display: "flex",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <Box>
          <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1rem", sm: "1.1rem" },
            fontWeight: "600",
            color: "#232325",
            mb: 1,
          }}
        >
          {title}
        </Typography>

        {title === "Crystal Ball Forecasting" && (
          <Typography sx={{
          fontFamily: "Plus Jakarta Sans",
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
          color: "rgba(255, 102, 0, 1)",
          lineHeight: 1.5,
          flex: 1,
          fontWeight: "500",
          margin: "0.5rem 0"
        }}>
          MRSI Golden Key Awards 2024 Finalist
        </Typography>
        )}    

        <Typography
          sx={{
            fontFamily: "Plus Jakarta Sans",
            fontSize: { xs: "0.8rem", sm: "0.9rem" },
            color: "#666",
            mb: 2,
            lineHeight: 1.5,
          }}
        >
          {description}
        </Typography>
        </Box>
        

        {/* Button Container */}
        <Box 
          sx={{ 
            display: "flex", 
            justifyContent: "flex-end",
            mt: "auto",
          }}
        >
          <Button
            sx={{
              backgroundColor: "#FF6600",
              color: "#FFFFFF",
              fontFamily: "Plus Jakarta Sans",
              fontSize: "0.9rem",
              fontWeight: "600",
              padding: "0.3rem 1rem",
              textTransform: "none",
              borderRadius: "0.5rem",
              marginBottom: "0.5rem",
              "&:hover": {
                backgroundColor: "#ff8533",
              },
              "& .MuiTouchRipple-root": {
                display: "none",
              },
            }}
          >
            Read More
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CaseStudyCard; 